/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-bootstrap/modal/modal-backdrop.component';
const styles_ModalBackdropComponent:any[] = ([] as any[]);
export const RenderType_ModalBackdropComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ModalBackdropComponent,
  data: {}
}
);
export function View_ModalBackdropComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_ModalBackdropComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'bs-modal-backdrop',[[
        'class',
        'modal-backdrop'
      ]
    ],(null as any),(null as any),(null as any),View_ModalBackdropComponent_0,RenderType_ModalBackdropComponent)),
    import0.ɵdid(57344,(null as any),0,import1.ModalBackdropComponent,[
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ModalBackdropComponentNgFactory:import0.ComponentFactory<import1.ModalBackdropComponent> = import0.ɵccf('bs-modal-backdrop',import1.ModalBackdropComponent,View_ModalBackdropComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3RtcC9zd2lmdC1idWlsZC9wcm9kL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy90bXAvc3dpZnQtYnVpbGQvcHJvZC9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1iYWNrZHJvcC5jb21wb25lbnQuZC50cyIsIm5nOi8vL3RtcC9zd2lmdC1idWlsZC9wcm9kL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5kLnRzLk1vZGFsQmFja2Ryb3BDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YnMtbW9kYWwtYmFja2Ryb3A+PC9icy1tb2RhbC1iYWNrZHJvcD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTs7O0lBQUE7S0FBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/ngx-bootstrap/modal/modal-backdrop.component.ngfactory.ts